export const formatClassNames = (...classNames: (string | undefined)[]) =>
  classNames?.filter(Boolean).join(' ') || '';
